import { render, staticRenderFns } from "./ComplianceStatisticPopup.vue?vue&type=template&id=0b86df04&scoped=true"
import script from "./ComplianceStatisticPopup.vue?vue&type=script&lang=js"
export * from "./ComplianceStatisticPopup.vue?vue&type=script&lang=js"
import style0 from "./ComplianceStatisticPopup.vue?vue&type=style&index=0&id=0b86df04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b86df04",
  null
  
)

export default component.exports